import { render } from "./MentionItem.vue?vue&type=template&id=4887f3a7&scoped=true"
import script from "./MentionItem.vue?vue&type=script&lang=js"
export * from "./MentionItem.vue?vue&type=script&lang=js"

import "./MentionItem.vue?vue&type=style&index=0&id=4887f3a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4887f3a7"]])

export default __exports__